import loadable from '@loadable/component';
import FullPageLoading from '../../components/Loading/FullPageLoading';

export const MARKETPLACE_PATHNAME = '/marketplace';

export const MarketplaceSearchLoadable = loadable(async () => import('./Search'), {
  fallback: <FullPageLoading background="color-dark" />,
});
